export class MerchantSettlementModel {
    BatchNumber: string;
    BatchId: string;
    SettlementNumber: string;
    SettlementDate: string;
    TotalTxn: number;
    TotalAmt: number;
    DiscAmt: number;
    NetAmt: number;
    ReconciledAmt:number;
    UnreconciledAmt:number;
    Status:string;
    PaymentDate:string;
    ROC:number;
    IssuerName:string;
    PAN:string;
    TxnDate:string;
    TxnType:string;
   // Aggregate: string;
    MerchantName: string;
    CutOffDate: string;
    Method: string;
    Gross: number;
    MDR: number;
    GST: number;
    Nett: number;
    TerminalNumber:string;
    Date: string;
    SettlementId:number;
}

export class MerchantSettlementSummaryDatewise{
    BatchNumber: string;
    BatchId: string;
    SettlementNumber: string;
    SettlementDate: string;
    TotalTxn: number;
    TotalAmt: number;
    DiscAmt: number;
    NetAmt: number;
    IssuerSettlementStatusId:number;
    Status:string;
    TerminalNumber:string;
    Paymentdate:string;
    SettlementId:number;
}
export class MerchantSettlementSummaryIndividual{
    BatchNumber: string;
    BatchId: string;
    SettlementNumber: string;
    SettlementDate: string;
    TotalTxn: number;
    TotalAmt: number;
    DiscAmt: number;
    NetAmt: number;
    Status:string;
    Paymentdate:string;
    SettlementId:number;
    ROC:number;
    Issuer:string;
    Mobile:string;
    TxnDate:string;
    TxnType:string;
    TerminalNumber:string;
}

export class MerchantSettlementListModel {
    TransactionDetails: MerchantSettlementModel[];
    TotalCount: number;
}

export class ServiceRequestModel{
    IssueTypeID:number;
    IssueTypeTitle:string;
    SubIssueTypeID:number;
    SubIssueTypeTitle:string;
    Description:string;
    constructor(){
        this.IssueTypeID=0;
        this.SubIssueTypeID=0;
    }
}

export class ServiceRequestDetails{
    RequestId:number;
    CustomRequestId:string;
    Description:string;
    TypeId:number;
    TypeName:string;
    SubTypeId:number;
    SubTypeName:string;
    Date:string;
    Status:string;
}

export class HelpDeskModel{
    CustomerCode:number;
    CustomerId:number;
    TicketNumber:string
    TicketId:number;
    IssuerId:number;
    MerchantName:string;
    MerchantCode:number;
    OutletId:number;
    StateId:number;
    CityId:number;
    CustomerName:string;
    CustomerMobileNo:string;
    IssueType:number=0;
    IssueDescription:string;
    Status:number=0;
    Comments:string;
    RaisedOn = new Date;
    RaisedOnDate: string;
    RaisedBy:string;
    FromDate = new Date;
    ToDate = new Date;
    OutletName:string;
    Address:string;
    IssueTypeData:string;
    StatusData:string;
    OutletPhoneNo1:string;
    OutletMobileNo1:string;
    OutletLandlineNo1:string;
    OutletEmail1:string;
    TerminalCode:number;
    MerchantExternalId:string;
    OutletAddress:string;
    TicketTypeId:number=0;
    IssuerName:string;
    TerminalId:number;
    FileName:string;
}

export class TicketCountModel{
    OpenTicketCount:number;
    ClosedTicketCount:number;
    InProgressTicketCount:number;
}



// WEBPACK FOOTER //
// ./src/app/models/merchant-settlement-model/merchant-settlement-model.ts